import { Modal, ModalProps } from 'ui';

import { CampaignDonationOptionsContent } from './CampaignDonateOptions';

interface CampaignDonateOptionsModal extends ModalProps {
  storeItemId?: string;
  storeId?: string;
}

const CampaignDonateOptionsModal = ({
  opened,
  onClose,
  title,
  storeId,
  storeItemId,
}: CampaignDonateOptionsModal) => {
  return (
    <Modal opened={opened} onClose={onClose} title={title}>
      <CampaignDonationOptionsContent storeId={storeId} storeItemId={storeItemId} />
    </Modal>
  );
};

export { CampaignDonateOptionsModal };
